import React, { memo, useEffect } from "react";
import { useAuth } from "../providers/AuthProvider";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";

const UserRoute = memo(function UserRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useAuth();

  useEffect(() => {
    if (session?.status === "unauthorized") {
      navigate("/authentication");
    } else if (
      session?.status === "authorized" &&
      session?.user?.roleCode === "admin"
    ) {
      navigate("/admin/dashboard");
    }
  }, [session?.status, session?.user?.roleCode, navigate]);

  if (session?.status === "loading") {
    return <LoadingFallback />;
  }

  return session?.status === "authorized" && session?.user?.roleCode === "user"
    ? children
    : null;
});

export default UserRoute;
